// extracted by mini-css-extract-plugin
export default {"socialWrapper":"SocialForm_socialWrapper__YiIqf","socialBtn":"SocialForm_socialBtn__NABBZ"};